module.exports = __webpack_public_path__ + "static/media/promo_banner_showcase.0e49339c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/img/optimized/promo_banner_showcase.webp
// module id = 251
// module chunks = 0